import StarterKit from '@tiptap/starter-kit';
import Link from '@tiptap/extension-link';
import TextAlign from '@tiptap/extension-text-align';
import Underline from '@tiptap/extension-underline';
import GlobalDragHandle from 'tiptap-extension-global-drag-handle';
import BlocksWithLabels from '../utils/BlocksWithLabels';
import TextUpdater from '../utils/TextUpdater';

export const defaultConfig = {
  extensions: [
    StarterKit,
    Underline,
    BlocksWithLabels,
    GlobalDragHandle,
    TextUpdater,
    Link.configure({
      openOnClick: false,
      autolink: true,
      defaultProtocol: 'https',
    }),
    
    TextAlign.configure({
      types: ['heading', 'paragraph', 'list-item', 'blockquote'],
      alignments: ['left', 'center', 'right', 'justify'],
      defaultAlignment: 'left',
    }),
  ],
};